module.exports = __webpack_public_path__ + "static/media/view-icon.d0bb4317.svg";